import { render, staticRenderFns } from "./IbanEditResultMsg.vue?vue&type=template&id=1d129a1d"
import script from "./IbanEditResultMsg.vue?vue&type=script&lang=ts"
export * from "./IbanEditResultMsg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports